/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_AsideInputs */

const en_contact_aside = /** @type {(inputs: Contact_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Booking is faster online. For everything else, call or write.`)
};

const pl_contact_aside = /** @type {(inputs: Contact_AsideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezerwacja online jest szybsza. W pozostałych sprawach zadzwoń albo napisz.`)
};

/**
* | output |
* | --- |
* | "Booking is faster online. For everything else, call or write." |
*
* @param {Contact_AsideInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const contact_aside = /** @type {((inputs?: Contact_AsideInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_AsideInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_contact_aside(inputs)
	return en_contact_aside(inputs)
});